import { PLAYABLE_EXTERNAL_CLAIM } from 'constants/api'
import axios from 'axios'
import ExchangeComponent from 'components/exchange'
import LoadingScreen from 'components/loading-screen'
import { useSession } from 'contexts/session-context'
import useRouter from 'hooks/use-router'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import textServices from 'services/text-services'
import { Prize } from 'views/prizes/types'

type ClaimPrize = Prize & {
  points?: number
  stickerId?: number
  couponTypeId?: number
  prizeNumber?: number
}

const GameClaim = () => {
  const [{ data: session }] = useSession()
  const { match } = useRouter()
  const history = useHistory()
  const [prize, setPrize] = useState<ClaimPrize | null>(null)

  const gameId = match?.params?.gameId as string

  useEffect(() => {
    const claimGame = async () => {
      if (!gameId) {
        history.push('/ranking')
        return
      }

      if (!session) return

      try {
        const { data } = await axios.post(
          PLAYABLE_EXTERNAL_CLAIM.replace(':gameId', gameId),
          null,
          {
            headers: {
              Authorization: `Bearer ${((session as any)?._tokenResponse as any)?.idToken}`,
              'Ph-Api-Id': PH_API_ID ?? 1
            }
          }
        )

        if (data?.prize) {
          setPrize(data?.prize)
          return
        }

        history.push('/ranking')
      } catch (error) {
        history.push('/ranking')
      }
    }

    claimGame()
  }, [])

  if (prize) {
    return (
      <ExchangeComponent
        title={`¡Mmm...Ya se antoja canjear el premio, ${prize.title}`}
        buttons={{
          handleMenu: () => history.push('/profile/history'),
          handleButtonCommon: () => history.push('/profile/history'),
          handleButtonSticker: () => history.push('/profile/history'),
          text: textServices.findByText('game/claim/exchange/button', { es: 'VER MI PREMIO', en: 'SEE MY PRIZE' })
        }}
        item={prize}
        module="login"
      />
    )
  }

  return <LoadingScreen />
}

export default GameClaim
